import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, List} from 'antd'

@inject('store') @observer
class DeleteModal extends Component {
  handleOk = async () => {
    this.props.close()
    await this.props.store[this.props.tab]?.list.deleteSelected()
  }
  render() {
    const {tab} = this.props
    const {data, selected} = this.props.store[tab]?.list
    return(
      <Modal
        title='Are you sure you want to delete these algos?'
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
      >
        <List
          dataSource={data?.filter(el => selected.indexOf(tab === 'backtest' ? el.algo.id : el.id) !== -1)}
          renderItem={item => <List.Item key={item.id}>{tab === 'backtest' ? item.algo.name : item.name}</List.Item>}
        />
      </Modal>
    )
  }
}

export default DeleteModal
